import { AssignmentRequeridoModalForm } from "./AssignmentRequeridoModalForm"


const AssignmentRequeridoModalFormWrapper = () => {
    return (<AssignmentRequeridoModalForm />)
}

export {AssignmentRequeridoModalFormWrapper}